import axios from 'axios';

function errorHandler(error, reject) {
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}

export default {
    list(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'uraian', 'remark','createby', 'nmcategory', 'jasa', 'requestno','mrequestno', 'tgl1', 'tgl2', 'outstand', 'DimCol', 'DimColInfo', 'DimVal','approved','pr', 'statuswf', 'barter'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                let url = `/pr${str}`;
                if (obj.viewOption=='Header') {
                    url = `/pr/list${str}`;
                } 
          
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    save(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.post("pr", obj);
                resolve(data);

            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    remove(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.delete(`/pr/${obj.requestkey}`);
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject);
            }
        })
    },
    closed(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.put(`/pr/closed/${obj.reqdtlkey}`, obj);
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject);
            }
        })
    },
    
    detail(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`/pr/detail/${obj.requestkey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    actionhistory(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`/pr/actionhistory/${obj.requestkey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    exportxls(obj = {}) {
        return new Promise((resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'uraian', 'remark', 'createby', 'nmcategory', 'jasa', 'requestno','mrequestno', 'tgl1', 'tgl2', 'DimCol', 'DimColInfo', 'DimVal','approved','pr', 'statuswf','barter'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                let url = `/pr/exportxls${str}`;
                if (obj.viewOption=='Header') {
                    url = `/pr/exporthdrxls${str}`;
                } 
                axios({
                    url,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    if (obj.viewOption=='Header') {
                        link.setAttribute('download', 'purchase_request_header_list.xlsx');
                    } else {
                        link.setAttribute('download', 'purchase_request_list.xlsx');
                    }
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });

            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    approval(formData) {
        return new Promise(async (resolve, reject) => {
            try {
                console.log('File Name : ', formData.filename);
                const { data } = await axios.post("pr/send2wf", formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    approvalUndo(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.put(`/pr/send2wfCancel/${obj.requestkey}`);
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    print(obj){
        return new Promise(async (resolve, reject) => {
            try {
                console.log('obj',obj)
                if(obj.requestkey){
                    obj.typePR = obj.typePR || 'close';
                    const url = `/pr/print?requestkey=${obj.requestkey}&typePR=${obj.typePR}`;
                    const { data } = await axios.get(url);
                    const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                    resolve(link);
                }
                
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    }
};